import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';

const Vision = () => {
  const visionItems = [
    'Health Care', 'Education', 'Nutrition', 'Livelihood', 'Water', 'Sanitization', 'Social Justice', 'Religious'
  ];

  return (
    <section id="vision" className="py-5" style={{ backgroundColor: '#f4f7f9' }}>
      <Container>
        <h2 className="text-center mb-4" style={{ color: '#0a4a7d', fontFamily: 'Montserrat, sans-serif', fontWeight: '700' }}>Our Vision</h2>
        <Row>
          {visionItems.map((item, index) => (
            <Col md={4} className="mb-4" key={index}>
              <Card className="text-center h-100" style={{ border: 'none', boxShadow: '0 4px 8px rgba(0,0,0,0.05)' }}>
                <Card.Body>
                  <Card.Title style={{ fontFamily: 'Montserrat, sans-serif', color: '#0a4a7d' }}>{item}</Card.Title>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
};

export default Vision;